export default {
    isAuthenticated(state) {
        const user = localStorage.getItem('user');
        if (user !== null) {
            state.user = JSON.parse(user);
            return state.user;
        }
        return null;
    },
    StateTIProtocols: (state) => state.protocolsTI,
    StateRDProtocols: (state) => state.protocolsRD,
    StateEvents: (state) => state.events,
    StateExpiredEvents: (state) => state.expiredEvents,
    StateReports: (state) => state.reports,
    StateReportsUnsigned: (state) => state.reportsUnsigned,
    StateUser: (state) => state.user,
    StateTokenMemed: (state) => state.tokenMemed,     
    StateEnable: (state) => state.enable,
    StateReport: (state) => state.report,
    StateSpecialistsActives: (state) => state.specialistsActives,
    StateUrlReport: (state) => state.urlReport,
    StateUrlFile: (state) => state.urlFile,
    isModalSignatureRequiredOpen: state => state.isModalSignatureRequiredOpen,
    StateReportFields: (state) => state.reportFields,
    StateChatMessages: (state) => state.chatMessages,
    StateActiveConversationId: (state) => state.activeConversationId,
}